import React, { Component } from "react";
import { connect } from "react-redux";
import Sidebar from "../../app/common/util/Sidebar";
import NavBar from "../nav/NavBar/NavBar";
import UtilMenus from "../nav/Menus/UtilMenus";
import TabView from "./tabView/TabView";
import { openModal } from "../modal/modalActions";
import { fetchCustomerWithoutDist } from "./homeActions";
import {
  DBgetItem,
  getUserPermissions,
} from "../../app/common/util/genericUtils";
import { PermissibleRender } from "@brainhubeu/react-permissible";
import ValidateFromHome from "../orderPunching/modal/ValidateFromHome";
import LoadingModal from "../modal/LoadingModal";
import SimplePageLoader from "../../app/common/util/SimplePageLoader";

class Dashboard extends Component {
  state = {
    showWorkspaceLoader: false,
  };

  hideLoaderTimer = null;

  async componentDidMount() {
    const customerList = await DBgetItem("customerList");
    if (!customerList || customerList.length < 1) {
      this.props.fetchCustomerWithoutDist();
    }
  }

  componentDidUpdate(prevProps) {
    const wasLoading = this.isPreparing(prevProps);
    const isLoading = this.isPreparing(this.props);

    if (isLoading && !this.state.showWorkspaceLoader) {
      if (this.hideLoaderTimer) {
        clearTimeout(this.hideLoaderTimer);
        this.hideLoaderTimer = null;
      }
      this.setState({ showWorkspaceLoader: true });
      return;
    }

    // Debounce hide so brief gaps between chained API calls don't flash the page
    if (!isLoading && wasLoading && this.state.showWorkspaceLoader) {
      if (this.hideLoaderTimer) clearTimeout(this.hideLoaderTimer);
      this.hideLoaderTimer = setTimeout(() => {
        if (!this.isPreparing(this.props)) {
          this.setState({ showWorkspaceLoader: false });
        }
        this.hideLoaderTimer = null;
      }, 350);
    }
  }

  componentWillUnmount() {
    if (this.hideLoaderTimer) clearTimeout(this.hideLoaderTimer);
  }

  // Workspace prep only — order detail fetches use SimplePageLoader
  isPreparing = (props) =>
    Boolean(
      props.loadingCustomerList ||
        props.blankSelectionLoader ||
        props.loadingFormData
    );

  render() {
    const { openModal, loadingOrderData } = this.props;
    const { showWorkspaceLoader } = this.state;
    const userPermissions = getUserPermissions();

    return (
      <div className="dashboard-home">
        {showWorkspaceLoader && (
          <LoadingModal
            loadingCustomerList={this.props.loadingCustomerList}
            blankSelectionLoader={this.props.blankSelectionLoader}
            loadingFormData={this.props.loadingFormData}
          />
        )}
        {loadingOrderData && !showWorkspaceLoader && (
          <SimplePageLoader label="Loading order…" />
        )}
        <Sidebar />
        <NavBar />
        <div className="home-top-toolbar">
          <div className="home-top-toolbar-left">
            <PermissibleRender
              userPermissions={userPermissions}
              requiredPermissions={["can_view_pendingauth_orders"]}
            >
              <ValidateFromHome />
            </PermissibleRender>
          </div>
          <div className="home-top-toolbar-right">
            <UtilMenus openModal={openModal} />
          </div>
        </div>
        <TabView />
      </div>
    );
  }
}

const actions = {
  openModal,
  fetchCustomerWithoutDist,
};
const mapStateToProps = (state) => ({
  loadingCustomerList: state.home.loadingCustomerList,
  loadingOrderData: state.home.loadingOrderData,
  blankSelectionLoader: state.blankSelection.getOrderLoader,
  loadingFormData: state.orderForm.loadingFormData,
});

export default connect(
  mapStateToProps,
  actions
)(Dashboard);
